/**
 * Copyright Highway9 Networks Inc.
 */
import { UE_Simulator } from "~/types/ueSimulator";
import APIService from "./APIServices";

const ueDiagnosticsApi = new APIService<UE_Simulator>("diagnostics/ueSimulators");

export const diagnosticsUeService = {
  getDiagnosticsUe: ueDiagnosticsApi.getAll,
  createDiagnosticsUe: ueDiagnosticsApi.create,
  modifyDiagnosticsUe: ueDiagnosticsApi.update,
  deleteDiagnosticsUe: ueDiagnosticsApi.delete,
};
